module.exports = __webpack_public_path__ + "static/media/STAF_bokmål med engelsk_sentrert logo_pos(svart).c4b838d7.png";